var $2a8fe7dc6b71b8d6$exports = {};
$2a8fe7dc6b71b8d6$exports = {
    "invalidSelection": (args, formatter)=>`A(s) ${formatter.plural(args.selectedCount, {
            one: `data`,
            other: `datas`
        })} selecionada(s) n\xe3o est\xe1(\xe3o) dispon\xedvel/dispon\xedvel(eis).`
};


export {$2a8fe7dc6b71b8d6$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
